"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDateByTimeZoneStrict = void 0;
const date_fns_tz_1 = require("date-fns-tz");
const constants_1 = require("../constants");
const getUserTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
const getValidTimeZone = (date) => date.getTimezoneOffset() < constants_1.MOSCOW_TIME_ZONE_OFFSET
    ? getUserTimezone()
    : constants_1.TIME_ZONE_MOSCOW;
const convertDateByTimeZoneStrict = (date, timeZone) => {
    return (0, date_fns_tz_1.utcToZonedTime)(date, timeZone || getValidTimeZone(date));
};
exports.convertDateByTimeZoneStrict = convertDateByTimeZoneStrict;
